import { CalloutBox } from "@/components/Blog/CalloutBox";
import { ImageGrid } from "@/components/Blog/ImageGrid";
import { PricingTable } from "@/components/Blog/PricingTable";
import {
  H1,
  H2,
  H3,
  H4,
  Paragraph,
  InlineLink,
} from "@/components/ui/typography";

const MDXComponents = {
  H1,
  H2,
  H3,
  H4,
  Paragraph,
  InlineLink,
  CalloutBox,
  ImageGrid,
  PricingTable,
};

export default MDXComponents;
